export const SET_AUTH = 'auth/SET_AUTH';
export const SET_AUTH_LOADING = 'auth/SET_AUTH_LOADING';
export const CLEAR_AUTH = 'auth/CLEAR_AUTH';
